/*
Dilip-pds 10/31/2023 2700271704 added field based on Add/Remove Billing Indicator
Sohel 11/30/2023 2700271704 data calculation field disable css modified
*/
import {
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import {Clear, Search} from '@material-ui/icons';
import React, {useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
// import reusableInputStyles from '../../../../../components/InputStyles';
import {handleSearchRuleGroupFieldData} from '../../../../../redux/reducers/EventTactics/EventTactics';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const BillingIndicator = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {allBillingIndicator} = useSelector(({addEventTactic}) => addEventTactic);
  const dispatch = useDispatch();

  const applyToOptions = [
    {key: 'A', value: 'A - Account'},
    {key: 'S', value: 'S - Seed'},
    {key: 'R', value: 'R - Route'},
  ];
  const {
    setShowSearch,
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    handleBlur,
  } = props;
  // const classes = ReusableInputStyles();
  return (
    <>
      <Grid item xs={4} sm={4} className={`form-group ${classes.selectField}`}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            fullWidth
            name="applyTo"
            className={` select-gender ${classes.labelName}`}
            required
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched?.applyTo}
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            // error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {applyToOptions.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors && errors.applyTo}</FormHelperText>
      </Grid>

      <Grid item xs={4} sm={4} className={`form-group`}>
        <GuiAutoComplete
          classes={{
            option: classes.option,
          }}
          name="billingIndicator"
          id="billingIndicator"
          size="small"
          value={values.billingIndicator}
          options={allBillingIndicator.length > 0 ? allBillingIndicator : []}
          getOptionLabel={(option) => {
            return option && option?.billingIndicatorNumber
              ? option?.billingIndicatorNumber + ' - ' + option?.billingIndicatorName
              : '';
          }}
          renderOption={(option) => {
            return option && option?.billingIndicatorNumber
              ? option?.billingIndicatorNumber + ' - ' + option?.billingIndicatorName
              : '';
          }}
          onChange={(e, value) => {
            setFieldValue('billingIndicator', value);
          }}
          renderInput={(params) => (
            <div className="select-field">
              <GuiTextField
                className={` ${classes.labelName}`}
                {...params}
                variant="outlined"
                margin="dense"
                label="Value"
                placeholder="Select Value"
              />
            </div>
          )}
        />
      </Grid>

      <Grid item xs={4} sm={4} className={`form-group wait-date-disable-field`}>
        <TextField
          margin="dense"
          variant="outlined"
          placeholder={`Enter Data Calculation`}
          // className={` ${classes.labelName} ${classes.inputLabel}`}
          label={'Data Calculation'}
          className={`label-overflow ${classes.labelName}`}
          disabled
          // InputLabelProps={{
          //   shrink: true,
          // }}
          name={'dataCalculation'}
          value={values?.dataCalculation?.dataCalculation ? values?.dataCalculation?.dataCalculation : values?.dataCalculation ? values?.dataCalculation : ""}
          onChange={(e) => {
            setFieldValue('dataCalculation', e.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search
                  className={` ${classes.iconSearch}`}
                  onClick={() => {
                    dispatch(
                      handleSearchRuleGroupFieldData({
                        status: true,
                        fieldName: 'dataCalculation',
                        setFieldValue: setFieldValue,
                        setShowSearch: setShowSearch,
                        returnType: 'Text',
                      }),
                    );
                    setShowSearch(true);
                  }}
                  size="sm"
                />
                <Clear
                  className={` ${classes.iconSearch}`}
                  onClick={(e) => setFieldValue('dataCalculation', '')}
                />
              </InputAdornment>
            ),
          }}
          fullWidth
          // required
          onBlur={handleBlur}
          error={Boolean(touched?.dataCalculation && errors?.dataCalculation)}
        />
        <FormHelperText>
          {touched?.dataCalculation && errors && errors.dataCalculation}
        </FormHelperText>
      </Grid>
    </>
  );
};

export default BillingIndicator;
